import { render } from "./ticketstabs.vue?vue&type=template&id=62858373"
import script from "./ticketstabs.vue?vue&type=script&lang=js"
export * from "./ticketstabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__